"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSelectableCardUtilityClass = getSelectableCardUtilityClass;
exports.selectableCardClasses = void 0;
var _mui = require("@ori-ui/mui");
function getSelectableCardUtilityClass(slot) {
  return (0, _mui.generateUtilityClass)('SelectableCard', slot);
}
const selectableCardClasses = exports.selectableCardClasses = (0, _mui.generateUtilityClasses)('SelectableCard', ['root', 'main', 'content', 'disabled', 'selected', 'focusVisible', 'actionBanner', 'actionSlot', 'actionHover']);
var _default = exports.default = selectableCardClasses;
